import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, Menu } from 'app/components';
import './style';

const Tickets = (props) => {
  const {
    ticket,
    onEdit,
    onDelete,
    onToggle,
    onSoldStatusToggle,
    disableToggle,
    allowDelete,
  } = props;

  console.log(ticket, 'ticket');

  const menuItems = allowDelete
    ? [
      { id: 'Edit', label: 'Edit' },
      { id: 'Delete', label: 'Delete' },
      { id: 'SoldStatus', label: !ticket?.is_sold_out ? 'Mark as sold out' : 'Unmark as sold out' },
    ]
    : [{ id: 'Edit', label: 'Edit' },{ id: 'SoldStatus', label: !ticket?.is_sold_out ? 'Mark as sold out' : 'Unmark as sold out' }];

  const handleMenuClick = (item) => {
    if (item.id === 'Edit') {
      onEdit();
    } else if (item.id === 'Delete') {
      onDelete(ticket.id);
    } else if (item.id === 'SoldStatus') {
      onSoldStatusToggle(ticket.id);
    }
  };

  return (
    window.innerWidth <= 768 ? ( 
    <div className="w-full bg-white border border-grey-10 rounded-2xl p-4 shadow-sm mb-4">
    {/* Header */}
    <div className="flex justify-between items-center mb-2">
      <div className="font-semibold text-[16px] text-black">
        {ticket.option_value_1}
      </div>

      {!disableToggle && (
        <Menu
          menuItems={menuItems}
          onClick={handleMenuClick}
        />
      )}
    </div>

    {/* Tickets sold + price */}
    <div className="flex justify-between items-center mb-1">
      <div className="text-[14px] text-gray-700 flex items-center gap-1">
        {`${ticket.quantity - ticket.available_quantity}/${ticket.quantity} tickets sold`}
        <span className="text-gray-400">·</span>
        {!ticket.price ? (
          <span>Free</span>
        ) : (
          <span>₹ {ticket.price}</span>
        )}
      </div>

      <Toggle
        checked={ticket?.is_active}
        onChange={() => onToggle(ticket.id, ticket?.option_value_1)}
        disabled={disableToggle}
      />
    </div>

    {/* Availability */}
    <div className="text-[13px] text-gray-500 mb-2">
      Available for sale
    </div>

    {/* Description */}
    {ticket.description && (
      <div className="pt-2">
        <hr className="border-grey-5 mb-2" />
        <div className="text-[14px] text-gray-800 leading-[20px]">
          {ticket.description}
        </div>
      </div>
    )}

  </div>):(
    <div className="px-8 py-6 shadow-xs rounded-2xl border border-grey-10 relative">
      <div className="heading-16 flex justify-between pb-3">
        {ticket.option_value_1}
        <div className="ticket-menu">
          {!disableToggle && (<Menu
            menuItems={menuItems}
            onClick={handleMenuClick}
          />)}
        </div>
      </div>
      <div className="flex justify-between pb-5 items-center">
        <div className="flex gap-2 items-center">
          <div> {` ${ticket.quantity - ticket.available_quantity}/${ticket.quantity} tickets sold`} </div>
          <span className="self-center mb-2.5">.</span>
          {!ticket.price ? <div>Free</div> : <div>₹ {ticket.price}</div>}
        </div>
        <div className="text-12 flex gap-3 items-center">
          Available for sale
          <Toggle
            checked={ticket?.is_active}
            onChange={() => onToggle(ticket.id, ticket?.option_value_1)}
            disabled={disableToggle}
          />
        </div>
      </div>
      {ticket.description && (
        <>
          <hr className="pb-5 accent-grey-5" />
          <div className="text-16">{ticket.description}</div>
        </>
      )}
    </div>
    ) 
  );
};

Tickets.propTypes = {
  ticket: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  availableForSale: PropTypes.bool.isRequired,
  onSoldStatusToggle: PropTypes.func.isRequired,
};

Tickets.defaultProps = {
  ticket: {},
  onToggle: () => null,
  onEdit: () => null,
  onDelete: () => null,
  availableForSale: false,
  onSoldStatusToggle: () => null,
};

export default Tickets;
